/**
 * @typedef {{
 *     Email: string,
 *     FirstName: string,
 *     LastName: string,
 *     Company: string,
 *     Company_Size_Range__c: string,
 *     Country: string,
 *     State: string,
 *     marketingConsent: string,
 *     URL: string,
 *     _mktoReferrer: string,
 *     formVid: string,
 *     munchkinId: string,
 *     _mkt_trk: string,
 *     HQ_Country__c: string,
 *     HQ_State__c: string,
 *     Marketing_Channels__c: string,
 *     Email_Sends_per_Month_Range__c: string,
 *     demoRequestNotesImport: string,
 *     Phone: string,
 *     Email_Verification_Status__c: string,
 *     kickboxReason: string,
 *     Locale__c: string,
 *     Primary_Use_Case__c: string,
 *     formid: string
 * }} Whitepaper2024FormData
 *
 * @param formData {Whitepaper2024FormData}
 * @param logType {GoogleSheetsLogType}
 * @return {GoogleSheetFormData}
 */
module.exports = function convertWhitepaper2024FormDataToGoogleSheetsFormData(formData, logType) {
    return { // TODO: Figure out why this is not assignable!!!
        'JSON Payload': JSON.stringify(formData, null, 2),
        Email: formData['Email'],
        FirstName: formData["FirstName"],
        LastName: formData["LastName"],
        Company: formData["Company"],
        Company_Size_Range__c: formData["Company_Size_Range__c"],
        Country: formData["Country"],
        State: formData["State"],
        marketingConsent: formData["marketingConsent"],
        URL: formData["URL"],
        _mktoReferrer: formData["_mktoReferrer"],
        formVid: formData["formVid"],
        munchkinId: formData["munchkinId"],
        _mkt_trk: formData["_mkt_trk"],
        HQ_Country__c: formData["HQ_Country__c"],
        HQ_State__c: formData["HQ_State__c"],
        Marketing_Channels__c: formData["Marketing_Channels__c"],
        Email_Sends_per_Month_Range__c: formData["Email_Sends_per_Month_Range__c"],
        demoRequestNotesImport: formData["demoRequestNotesImport"],
        demoRequestEmailProvider: formData["demoRequestEmailProvider"],
        Phone: formData["Phone"],
        Email_Verification_Status__c: formData["Email_Verification_Status__c"],
        kickboxReason: formData["kickboxReason"],
        Locale__c: formData["Locale__c"],
        Primary_Use_Case__c: formData["Primary_Use_Case__c"],
        formid: formData["formid"],
        LOG_TYPE: logType,
    };
}
